// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a5Tne","label":"styles_label__2RNX4"};